import { useState } from "react";
import EsgGuideBlog from "../../../../components/esg-guide/blog/Esg-guide-blog";
import EsgLayout from "../../../../components/esg-guide/Esg-layout";
import Layout from "../../../../components/layout/Layout";
import { SeoMeta } from "@/utils/seo/SeoMeta";

const BlogPage = () => {
  return (
    <>
      <Layout
        parent={"홈"}
        sub={"ESG 자료실"}
        subTitle={"제작사례 & 포장재리뷰"}
        pageTitle={SeoMeta.caseStudiesAndPackagingReviews.title}
        pageDesc={SeoMeta.caseStudiesAndPackagingReviews.description}
        pageKeyword={SeoMeta.caseStudiesAndPackagingReviews.keywords}
      >
        <EsgLayout blogMenu={1}>
          <EsgGuideBlog blogMenu={1} />
        </EsgLayout>
      </Layout>
    </>
  );
};
export default BlogPage;
